import styled from '@emotion/styled';

export const CircleWrapper = styled('path')(({ theme }) => ({
  fill: 'none',
  strokeWidth: 2.8,
  strokeLinecap: 'round',
  animation: '$progress 1s ease-out forwards'
}));

export const CircleBackgroundWrapper = styled('path')(({ theme }) => ({
  fill: 'none',
  stroke: '#f5f9ff',
  strokeWidth: 2.8
}));
